export const VARIABLES = {
  GLOBAL_STATE: "FIT_globalState",
  IS_APP_STORE: "FIT_isAppStore",
  STRIPE: "FIT_Stripe"
}

export const globalState = () => window[VARIABLES.GLOBAL_STATE]
export const isAppStore = () => window[VARIABLES.IS_APP_STORE]
